// Cliente CEC — POST al backend (hub-api). Caché local 24h.
// Si el remoto responde vacío (el webhook `cec` hoy da 200 sin cuerpo), se sirve
// el catálogo curado de `constants.js` para que el modelado no se quede sin Voc/Vmp.

import { hubPost } from './hub';
import { DEFAULT_PANELS, DEFAULT_INVERTERS } from '../constants';

const CACHE_PREFIX = 'cec:';
const CACHE_TTL_MS = 24 * 60 * 60 * 1000;

function readCache(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (Date.now() - p.t > CACHE_TTL_MS) return null;
    return p.d;
  } catch { return null; }
}

function writeCache(key, data) {
  try { localStorage.setItem(key, JSON.stringify({ t: Date.now(), d: data })); } catch {}
}

async function searchCEC(type, query, limit = 20) {
  const key = `${CACHE_PREFIX}${type}:${query}:${limit}`;
  const cached = readCache(key);
  if (cached) return { ...cached, cached: true };

  let data;
  try {
    data = await hubPost('cec', { type, q: query || '', limit });
  } catch (e) {
    data = { ok: false, reason: e.message };
  }
  // 200 vacío (el webhook viejo) y ok:false no se cachean.
  const valid = data && data.ok !== false && Array.isArray(data.results) && data.results.length > 0;
  if (valid) {
    writeCache(key, { ...data, cached: false });
    return data;
  }
  return respaldoCEC(type, query, limit);
}

function respaldoCEC(type, query, limit) {
  const t = (query || '').trim().toLowerCase();
  if (type === 'panel') {
    const results = DEFAULT_PANELS
      .filter((p) => !t || `${p.brand} ${p.model}`.toLowerCase().includes(t))
      .slice(0, limit)
      .map((p) => ({
        id: p.id, brand: p.brand, model: p.model, fullName: `${p.brand} ${p.model}`,
        wp: p.wp, voc: p.voc, vmp: p.vmp, isc: p.isc, imp: p.imp,
        tempCoeffPmax: p.tempCoeffPmax, tempCoeffVoc: p.tempCoeffVoc,
        cellCount: p.cellCount, length_m: (p.lengthMm || 0) / 1000, width_m: (p.widthMm || 0) / 1000,
        source: 'catálogo curado ALEBAS (respaldo)',
      }));
    return { ok: true, type, results, count: results.length, total: results.length, source: 'respaldo' };
  }
  const results = DEFAULT_INVERTERS
    .filter((i) => !t || `${i.brand} ${i.model}`.toLowerCase().includes(t))
    .slice(0, limit)
    .map((i) => ({
      id: i.id, brand: i.brand, model: i.model, fullName: `${i.brand} ${i.model}`,
      kw: i.kw, phase: i.phase, vocMax: i.vocMax, mpptVmin: i.mpptVmin, mpptVmax: i.mpptVmax,
      mpptCount: i.mpptCount, idcMax: i.idcMax, vac: i.vac,
      source: 'catálogo curado ALEBAS (respaldo)',
    }));
  return { ok: true, type, results, count: results.length, total: results.length, source: 'respaldo' };
}

export const searchCECPanels    = (q, limit) => searchCEC('panel',    q, limit);
export const searchCECInverters = (q, limit) => searchCEC('inverter', q, limit);

// Limpia el caché local (útil cuando el workflow del servidor cambió o hubo
// respuestas malformadas que quedaron almacenadas).
export function invalidateCECCache() {
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith(CACHE_PREFIX)) keys.push(k);
    }
    keys.forEach(k => localStorage.removeItem(k));
    return keys.length;
  } catch { return 0; }
}
